export default {"src":"/_next/static/media/nftfy.5bd1bc36.svg","height":25,"width":24};